import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useFetchActiveMainProjectsQuery } from '../../../features/API/user-api-slice';
import { PageTitle } from '../../text';
import { useSelector } from 'react-redux';
import { Button } from '../../UI/button';
import Spinner from '../../UI/spinner';
import { useHistory } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const MainProjects = () => {
  const { data = [], isFetching } = useFetchActiveMainProjectsQuery();
  const { t } = useTranslation();
  const selectedLanguage = useSelector(
    (state) => state.global.selectedLanguage
  );
  const [imageConfiguration, setImageConfiguration] = useState({
    height: '100%',
    width: '100%',
  });
  const history = useHistory();

  // Function to truncate text
  const truncateText = (text, wordLimit) => {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  return isFetching ? (
    <Spinner />
  ) : (
    <div className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <PageTitle
          name={t('Our Projects')}
          color="red"
          alignment="center"
          mobileAlignment="center"
          additional="mb-12"
        />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {data.results.map((project, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 max-w-sm mx-auto">
              <div className="project-card-image relative h-48">
                <LazyLoadImage
                  className="w-full h-full object-cover"
                  effect="blur"
                  placeholderSrc="/images/logo.png"
                  afterLoad={() => {
                    setImageConfiguration({ height: '', width: '' });
                  }}
                  {...imageConfiguration}
                  src={`${process.env.REACT_APP_BACKEND_URL}/images/${project.gallery[0]}`}
                  alt={project.name}
                />
                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/60"></div>
              </div>
              <div className="project-card-content p-4 bg-white">
                <h3 className="text-lg font-bold text-gray-900 mb-2 capitalize">
                  {project.name}
                </h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">
                  {truncateText(project.smallDescription[selectedLanguage], 20)}
                </p>
                <div className="flex justify-center">
                  <Button
                    name={t('Read More')}
                    isSquare
                    outline="false"
                    color="red"
                    additional="px-4 py-2 text-xs font-semibold"
                    clicked={() => {
                      history.push(`/projects/${project._id}`);
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainProjects;
